import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface LogErrorDetailsData {
	error_details: string;
	message?: string;
	orderno?: string;
	created_at?: string;
}

@Component({
	selector: 'app-log-error-details-modal',
	templateUrl: './log-error-details-modal.component.html',
	styleUrls: ['./log-error-details-modal.component.scss']
})
export class LogErrorDetailsModalComponent {
	constructor(
		public dialogRef: MatDialogRef<LogErrorDetailsModalComponent>,
		@Inject(MAT_DIALOG_DATA) public data: LogErrorDetailsData
	) {}

	close(): void {
		this.dialogRef.close();
	}
}
